













































import Vue from "vue";
import ButtonAction from "../../components/ButtonAction.vue";
import Checkbox from "../../components/Checkbox.vue";
import UserListRow from "./UserListRow.vue";
import orderBy from "lodash-es/orderBy";
import axios, { AxiosPromise } from "axios";

import { UserRowViewModel } from "./UserListRow.vue";

export default Vue.extend({
  components: {
    ButtonAction,
    Checkbox,
    UserListRow
  },
  data() {
    return {
      loading: false,
      showinactief: false,
      searchText: "",
      users: [] as UserRowViewModel[]
    };
  },
  mounted() {
    this.loading = true;
    this.getUsers();
  },
  computed: {
    filteredUsers: function(): UserRowViewModel[] {
      let result: UserRowViewModel[] = this.showinactief
        ? [...this.users]
        : this.users.filter(u => u.Active);

      result =
        this.searchText.length < 1
          ? [...result]
          : result.filter(this.isUserMatch);

      return orderBy(result, ["Naam"], ["asc"]);
    }
  },
  methods: {
    getUsers() {
      axios
        .get("/api/backend/v1/users")
        .then(response => {
          if (!!response && !!response.data) {
            this.users = response.data as UserRowViewModel[];
            this.loading = false;
          }
        })
        .catch(error => {});
    },
    onNewBtnClicked() {
      const id = "00000000-0000-0000-0000-000000000000";
      this.$router.push({ name: "users", params: { id } });
    },
    toggleActive() {
      this.showinactief = !this.showinactief;
    },
    isSearchMatch(phrase: string): boolean {
      return !!phrase && !!this.searchText
        ? new RegExp(this.searchText, "ig").test(phrase)
        : false;
    },
    isUserMatch(sjabloon: UserRowViewModel): boolean {
      return (
        this.isSearchMatch(sjabloon.Naam) || this.isSearchMatch(sjabloon.Email)
      );
    }
  }
});
